export default __webpack_public_path__ + "static/media/Background.0d46a43e.png";